import React from 'react'
import "../Footer/Footer.css";
import "../About/About.css";
const Footer = () => {
  return (
    <footer id='fot' >
    <p id='pie'>© 2024 sitio web creado por <a className='website' href='www.ninnotech.com'>www.ninnotech.com</a> Todos los derechos reservados.</p>
  </footer>
  )
}

export default Footer